import { useState } from "react";
import { useContent } from "../content/ContentContext";
import { SectionLabel, ButtonLink } from "../components/Ui";
import { Reveal } from "../components/Reveal";
import PackageCard from "../components/PackageCard";

export default function PricingSection() {
  const { content } = useContent();
  const [selectedPackage, setSelectedPackage] = useState(null);
  const { site, packages } = content;
  const visible = packages.filter((p) => !p.hidden);
  return (
    <section id="pricing" data-testid="section-pricing" className="mx-auto max-w-7xl scroll-mt-24 px-4 py-12 sm:px-6 lg:px-8 lg:py-20">
      <Reveal>
        <SectionLabel>Pricing</SectionLabel>
        <h2 className="mt-5 max-w-3xl font-serif text-3xl font-semibold tracking-tight text-ink sm:text-4xl lg:text-5xl" data-testid="pricing-heading">
          {site.pricingHeading}
        </h2>
        <p className="mt-6 max-w-2xl text-lg leading-relaxed text-muted">&ldquo;{site.pricingIntro}&rdquo;</p>
      </Reveal>
      <div data-testid="pricing-packages-grid" className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-4">
        {visible.map((p, i) => (
          <Reveal key={p.id} delay={i * 0.08} className={`h-full ${p.recommended ? "max-md:order-first" : ""}`}>
            <PackageCard p={p} selected={selectedPackage === p.id} onSelect={() => setSelectedPackage(p.id)} />
          </Reveal>
        ))}
      </div>
      <Reveal className="mt-16">
        <div className="rounded-2xl border border-line bg-lavender p-8 sm:p-10">
          <h3 className="font-serif text-xl font-medium text-ink sm:text-2xl">
            Looking for a single, defined piece of work?
          </h3>
          <p className="mt-3 max-w-2xl leading-relaxed text-muted">
            The services section lists ten focused services — each with its own starting
            price, deliverables and scope notes.
          </p>
          <ButtonLink to="/#services" testid="pricing-services-link" className="mt-7">
            Browse individual services
          </ButtonLink>
        </div>
      </Reveal>
    </section>
  );
}
